import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-white shadow-md">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center">
            <img src="/logo.jpeg" alt="MoreLove Logo" className="h-14 mr-3" />
            <span className="text-primary font-bold text-xl hidden md:block">MoreLove</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-6">
            <Link to="/" className="text-primary hover:text-secondary transition-colors">
              Accueil
            </Link>
            <Link to="/about" className="text-primary hover:text-secondary transition-colors">
              Qui sommes-nous
            </Link>
            <Link to="/mission" className="text-primary hover:text-secondary transition-colors">
              Notre mission
            </Link>
            <Link to="/domains" className="text-primary hover:text-secondary transition-colors">
              Domaines d'intervention
            </Link>
            <Link to="/membership" className="text-primary hover:text-secondary transition-colors">
              Devenir membre
            </Link>
            <Link to="/contact" className="text-primary hover:text-secondary transition-colors">
              Contact
            </Link>
          </nav>

          <Link to="/donate" className="hidden md:block btn-donate">
            Faire un don
          </Link>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-primary"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 space-y-3">
            <Link
              to="/"
              className="block text-primary hover:text-secondary transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Accueil
            </Link>
            <Link
              to="/about"
              className="block text-primary hover:text-secondary transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Qui sommes-nous
            </Link>
            <Link
              to="/mission"
              className="block text-primary hover:text-secondary transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Notre mission
            </Link>
            <Link
              to="/domains"
              className="block text-primary hover:text-secondary transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Domaines d'intervention
            </Link>
            <Link
              to="/membership"
              className="block text-primary hover:text-secondary transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Devenir membre
            </Link>
            <Link
              to="/contact"
              className="block text-primary hover:text-secondary transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </Link>
            <Link
              to="/donate"
              className="block btn-donate inline-block mt-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Faire un don
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
